<soft-page customClass="!p-0">
  <soft-page-panel panelStyle="plain" class="overflow-y-auto">
    @if (isMobile()) {
      <soft-page-panel-header>
        <soft-filter-and-sort
          class="w-full mb-2"
          [explorer]="explorerAbteilungen"
          [filterConfig]="filterConfig"
          [sortConfig]="sortConfig"
          (input)="updateQueryParams($event)"
        ></soft-filter-and-sort>
      </soft-page-panel-header>
    }
    @if (loadError()) {
      <soft-ds-empty-state
        class="m-auto"
        variant="error"
        size="lg"
        title="Daten konnten nicht geladen werden"
        description="Beim Laden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
        actionLabel="Erneut versuchen"
        (action)="refresh()"
        data-testid="statusabfrage-abteilungen-error"
      />
    } @else {
      @if (filteredItems$ | async; as abteilungen) {
        @if (abteilungen.length > 0 || (loading$ | async) === false) {
          @if ((explorerAbteilungen.result() ?? []).length === 0) {
            <soft-ds-empty-state
              class="m-auto"
              variant="empty"
              size="lg"
              icon="fa-regular fa-sad-cry"
              title="Keine Abteilungen gefunden"
              [description]="
                isNarrowed()
                  ? 'Die Suche oder der Filter blendet alle Abteilungen aus.'
                  : null
              "
              [actionLabel]="isNarrowed() ? 'Suche und Filter zurücksetzen' : null"
              (action)="resetSearch()"
              data-testid="statusabfrage-abteilungen-empty"
            />
          } @else if (viewMode() === 'grid') {
            <div
              class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 select-none pt-0.5"
            >
              @for (abteilung of explorerAbteilungen.result(); track abteilung.id) {
                <soft-abteilung-card
                  [grid]="true"
                  [abteilung]="abteilung"
                  [routerLink]="[
                    './abteilung',
                    $safeNavigationMigration(abteilung?.abteilung?.id),
                  ]"
                  [queryParamsHandling]="'preserve'"
                ></soft-abteilung-card>
              }
            </div>
          } @else {
            <div class="flex flex-col gap-2 select-none pt-0.5">
              @for (abteilung of explorerAbteilungen.result(); track abteilung.id) {
                <soft-abteilung-card
                  [grid]="false"
                  [abteilung]="abteilung"
                  [routerLink]="[
                    './abteilung',
                    $safeNavigationMigration(abteilung?.abteilung?.id),
                  ]"
                  [queryParamsHandling]="'preserve'"
                ></soft-abteilung-card>
              }
            </div>
          }
        }
      }
    }
  </soft-page-panel>
</soft-page>
<ng-template #viewSwitchBar>
  <soft-ds-button-group
    layout="attached"
    variant="outline"
    size="md"
    aria-label="Anzeige"
    data-testid="statusabfrage-view-switch"
  >
    @for (option of viewOptions; track option.value) {
      <soft-ds-button
        mode="iconOnly"
        [variant]="viewMode() === option.value ? 'secondary' : 'outline'"
        [aria-label]="option.label"
        [title]="option.label"
        [attr.data-testid]="'statusabfrage-view-' + option.value"
        (click)="viewMode.set(option.value)"
      >
        <ng-template softSlot="leading">
          <soft-ds-icon [name]="option.icon" />
        </ng-template>
      </soft-ds-button>
    }
  </soft-ds-button-group>
</ng-template>

<ng-template #searchBar>
  <soft-filter-and-sort
    class="w-96"
    [explorer]="explorerAbteilungen"
    [filterConfig]="filterConfig"
    [sortConfig]="sortConfig"
    (input)="updateQueryParams($event)"
  ></soft-filter-and-sort>
</ng-template>

<ng-template #trailingActionBar>
  <div class="flex items-center gap-2 h-full">
    @if (lastLoadedLabel(); as time) {
      <span
        class="ds-caption text-light whitespace-nowrap"
        data-testid="statusabfrage-last-loaded"
      >
        Stand {{ time }}
      </span>
    }
    <soft-ds-button
      variant="outline"
      size="md"
      mode="iconOnly"
      title="Aktualisieren"
      data-testid="statusabfrage-refresh"
      (click)="refresh()"
    >
      <ng-template softSlot="leading">
        <soft-ds-icon name="fa-regular fa-arrows-rotate" />
      </ng-template>
    </soft-ds-button>
  </div>
</ng-template>
